module.exports = __webpack_public_path__ + "img/nextrack_logo.510b749f.svg";